/* Meraki theme scripts — no dependencies */
(function () {
  'use strict';

  var scrim = null;
  var openPanel = null;

  function getScrim() {
    if (!scrim) scrim = document.querySelector('[data-overlay-scrim]');
    return scrim;
  }

  function lockScroll(on) {
    document.body.classList.toggle('is-locked', !!on);
  }

  function openOverlay(panel) {
    if (!panel) return;
    if (openPanel && openPanel !== panel) closeOverlay(openPanel);
    panel.setAttribute('aria-hidden', 'false');
    var s = getScrim();
    if (s) { s.hidden = false; requestAnimationFrame(function () { s.classList.add('is-visible'); }); }
    lockScroll(true);
    openPanel = panel;
    var focusable = panel.querySelector('button, [href], input, select, textarea');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  function closeOverlay(panel) {
    panel = panel || openPanel;
    if (!panel) return;
    panel.setAttribute('aria-hidden', 'true');
    var s = getScrim();
    if (s) {
      s.classList.remove('is-visible');
      setTimeout(function () { if (!openPanel) s.hidden = true; }, 420);
    }
    lockScroll(false);
    if (openPanel === panel) openPanel = null;
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-open]');
    if (openBtn) {
      e.preventDefault();
      openOverlay(document.getElementById(openBtn.getAttribute('data-open')));
      return;
    }
    if (e.target.closest('[data-close]') || e.target.closest('[data-overlay-scrim]')) {
      e.preventDefault();
      closeOverlay();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) closeOverlay();
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var next = (parseInt(input.value, 10) || min) + parseInt(btn.getAttribute('data-qty-step'), 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variant selection ---------- */
  function initVariantPicker(root) {
    var data = root.querySelector('[data-variant-json]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }

    var form = root.querySelector('form[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price-target]');
    var addBtn = root.querySelector('[data-add-button]');
    var stockEl = root.querySelector('[data-stock]');
    var skuEl = root.querySelector('[data-sku]');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function match(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
    }

    function update() {
      var v = match(selected());
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.querySelector('span').textContent = window.themeStrings.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl && v.price_html) priceEl.innerHTML = v.price_html;
      if (skuEl) skuEl.textContent = v.sku || '';
      if (stockEl) {
        stockEl.classList.toggle('stock--out', !v.available);
        stockEl.textContent = v.available ? (v.inventory_message || 'In stock') : window.themeStrings.soldOut;
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.querySelector('span').textContent = v.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
      }
      if (v.featured_media_id) {
        var media = root.querySelector('[data-media-id="' + v.featured_media_id + '"]');
        if (media) media.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index] input')) update();
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (document.body.getAttribute('data-cart-type') !== 'drawer') return;
        e.preventDefault();
        var fd = new FormData(form);
        addBtn && (addBtn.disabled = true);
        fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function () { return refreshCart(true); })
          .catch(function () { form.submit(); })
          .finally(function () { addBtn && (addBtn.disabled = false); });
      });
    }

    update();
  }

  /* ---------- Cart ---------- */
  function refreshCart(open) {
    return fetch(window.routes.cart_url ? window.routes.cart_url + '?section_id=cart-drawer' : '/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-contents]');
        var current = document.querySelector('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        if (open) openOverlay(document.getElementById('CartDrawer'));
        return cart;
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(remove.getAttribute('data-line'), 0);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line'), parseInt(input.value, 10) || 0);
  });

  function changeLine(line, quantity) {
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function () { return refreshCart(false); })
      .catch(function () { window.location.reload(); });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Init ---------- */
  function init(scope) {
    (scope || document).querySelectorAll('[data-product-root]').forEach(initVariantPicker);
    initReveal();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.MerakiTheme = { openOverlay: openOverlay, closeOverlay: closeOverlay, refreshCart: refreshCart };
})();
